import { render, staticRenderFns } from "./CheckinsList.vue?vue&type=template&id=fb788632"
import script from "./CheckinsList.vue?vue&type=script&lang=js"
export * from "./CheckinsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports